import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 8a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M13 12l5 0","key":"svg-1"}],["path",{"d":"M20 6h-6a1 1 0 0 0 -1 1v11","key":"svg-2"}]]

const IconTemperatureFahrenheit = createReactComponent('outline', 'temperature-fahrenheit', 'TemperatureFahrenheit', __iconNode);

export default IconTemperatureFahrenheit;